/* js/cardRow-block.js */


jQuery(document).ready(function ($) {

    $(window).scroll(function () {
        $('.card').each(function () {
            var imagePos = $(this).offset().top;

            var topOfWindow = $(window).scrollTop();
            if (imagePos < topOfWindow + 800) {
                $(this).addClass('cardRow-animated');

            }
        });
    });


    $(window).scroll(function () {
        $('.review-block-test').each(function () {
            var imagePos = $(this).offset().top;

            var topOfWindow = $(window).scrollTop();
            if (imagePos < topOfWindow + 400) {
                $(this).addClass('test-in-view');

            }
        });
    });
});